import { FC } from 'react';
import { Tooltip, Typography } from '@mui/material';

import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Row from '../../../../../components/Row';
import { AdminPanelSettingsOutlined as AdminPanelSettingsOutlinedIcon } from '@mui/icons-material';

import { Campaign, Platform } from '../../../../../types/Campaign';
import CampaignPlatformOverviewList from '../List/CampaignPlatformOverviewList';

interface CampaignPlatformOverviewCardProps {
    campaign: Campaign;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignPlatformOverviewCard: FC<CampaignPlatformOverviewCardProps> = ({ campaign, slotProps = {} }) => {
    return (
        <CollapsibleCard
            {...slotProps?.collapsibleCard}
            sx={{
                '& .MuiCardContent-root:last-child': {
                    p: 0,
                },
            }}
        >
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">
                            {campaign.platform === Platform.AMAZON ? 'Amazon DSP' : 'DV360'}
                        </Typography>

                        <Tooltip title="Visible to Admins Only">
                            <AdminPanelSettingsOutlinedIcon color="primary" />
                        </Tooltip>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent sx={{ p: 0 }}>
                    <CampaignPlatformOverviewList campaign={campaign} />
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignPlatformOverviewCard;
